import Vue from 'vue'
import VueRouter from 'vue-router'
import expo from '../config/expo'
import Demo from '../views/Demo'
import ExhibitionIntroduction from  '../views/ExhibitionIntroduction'
import ExhibitionInformation from  '../views/ExhibitionInformation'
import ExhibitionInformationDetails from  '../views/ExhibitionInformationDetails'
import ExhibitionOverview from  '../views/ExhibitionOverview'
import ExhibitionService from  '../views/ExhibitionService'
import Exhibitors from  '../views/Exhibitors'
import Contact from  '../views/Contact'
import Information from  '../views/Information'
import Download from '../views/Download'
import Visit from  '../views/Visit'
import InstitutionalFramework from  '../views/InstitutionalFramework'
import ActivityIntroduction from  '../views/ActivityIntroduction'
import Organization from  '../views/Organization'
import ScopeExhibits from  '../views/ScopeExhibits'
import InformationDetail from  '../views/InformationDetail'
import AdvertisingContribution from  '../views/AdvertisingContribution'
import SellerRegister from  '../views/SellerRegister'
import GoWechat from '../views/ticket/index.vue'
import SpecialAudit from "../views/special/SpecialAudit.vue";
import SpecialHome from "../views/special/SpecialHome.vue";
import SpecialCode from "../views/special/SpecialCode.vue";
import AuditSuccess from "../views/special/AuditSuccess.vue";
import SpecialPolicy from "../views/special/SpecialPolicy.vue";
import SignMap from "../views/activity/SignMap";
import Exhibitor from "../views/exhibitor/face";
import ActivityReceive from "../views/activity/ActivityReceive";
import ExhibitorScan from "../views/activity/ExhibitorScan.vue";
import ServiceScan from "../views/activity/ServiceScan.vue";
import GiftList from "../views/activity/GiftListService";
import PetFriendly from "../views/ticket/pet";

Vue.use(VueRouter)

/* ========== SEO 相关常量（换届集中配置见 src/config/expo.js） ========== */

// 首页标题（主推品牌 + 届次）
const homeTitle = expo.homeTitle;
// 内页统一品牌词：标题格式「页面名 | 品牌词」
const siteTitle = expo.siteTitle;
// 全站统一 keywords
const siteKeywords = expo.keywords;
// 首页 description
const homeDesc = expo.homeDesc;
// 默认 description（未单独配置 description 的路由使用）
const defaultDesc = expo.defaultDesc;
/* ============================================================ */

const routes = [
    {
        path: '/',
        name: 'Demo',
        component: Demo,
        meta: {
            title: homeTitle,
            description: homeDesc,
            keywords: siteKeywords,
        },
    },
    {
        path: '/exhibitionIntroduction',
        name: 'ExhibitionIntroduction',
        component: ExhibitionIntroduction,
        meta: {
            name: '交通指南',
            description: '趣宠会（天津国际AI+宠物产业博览会）交通指南栏目，提供观展交通出行相关的官方指引。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ExhibitionInformation',
        name: 'ExhibitionInformation',
        component: ExhibitionInformation,
        meta: {
            name: '展会公告',
            description: '趣宠会（天津国际AI+宠物产业博览会）展会公告栏目，发布展会最新官方公告与通知。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ExhibitionInformationDetails',
        name: 'ExhibitionInformationDetails',
        component: ExhibitionInformationDetails,
        meta: {
            name: '展会公告详情',
            description: '趣宠会（天津国际AI+宠物产业博览会）展会公告详情页。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ExhibitionOverview',
        name: 'ExhibitionOverview',
        component: ExhibitionOverview,
        meta: {
            name: '展会介绍',
            description: '第五届趣宠会（天津国际AI+宠物产业博览会）展会介绍：聚焦AI+宠物产业，汇集宠物行业优质品牌，欢迎参观参展。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ExhibitionService',
        name: 'ExhibitionService',
        component: ExhibitionService,
        meta: {
            name: '展会服务',
            description: '趣宠会（天津国际AI+宠物产业博览会）展会服务栏目，提供参展、参观相关服务指引。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/Exhibitors',
        name: 'Exhibitors',
        component: Exhibitors,
        meta: {
            name: '展商服务',
            description: '趣宠会（天津国际AI+宠物产业博览会）展商服务栏目，为参展企业提供报名及参展相关服务指引。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/Contact',
        name: 'Contact',
        component: Contact,
        meta: {
            name: '联系我们',
            description: '趣宠会（天津国际AI+宠物产业博览会）联系我们栏目，提供组委会联系方式与合作通道。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/Information',
        name: 'Information',
        component: Information,
        meta: {
            name: '行业资讯',
            description: '趣宠会（天津国际AI+宠物产业博览会）行业资讯栏目，汇集宠物行业动态与展会新闻。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/Download',
        name: 'Download',
        component: Download,
        meta: {
            name: '下载中心',
            description: '趣宠会（天津国际AI+宠物产业博览会）下载中心栏目，提供参展申请表等展会资料下载。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ActivityIntroduction',
        name: 'ActivityIntroduction',
        component: ActivityIntroduction,
        meta: {
            name: '同期活动',
            description: '趣宠会（天津国际AI+宠物产业博览会）同期活动栏目，介绍展会同期论坛与主题活动。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/Organization',
        name: 'Organization',
        component: Organization,
        meta: {
            name: '组织机构',
            description: '趣宠会（天津国际AI+宠物产业博览会）组织机构栏目，介绍展会主办及组织单位架构。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ScopeExhibits',
        name: 'ScopeExhibits',
        component: ScopeExhibits,
        meta: {
            name: '展品范围',
            description: '趣宠会（天津国际AI+宠物产业博览会）展品范围栏目，介绍本届展会展示的宠物行业品类。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/InstitutionalFramework',
        name: 'InstitutionalFramework',
        component: InstitutionalFramework,
        meta: {
            name: '日程安排',
            description: '趣宠会（天津国际AI+宠物产业博览会）日程安排栏目，提供展会各时段活动安排信息。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/visit',
        name: 'Visit',
        component: Visit,
        meta: {
            name: '观众服务',
            description: '趣宠会（天津国际AI+宠物产业博览会）观众服务栏目，为到场观众提供观展指南与服务信息。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/InformationDetail',
        name: 'InformationDetail',
        component: InformationDetail,
        meta: {
            name: '资讯详情',
            description: '趣宠会（天津国际AI+宠物产业博览会）行业资讯详情页。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/AdvertisingContribution',
        name: 'AdvertisingContribution',
        component: AdvertisingContribution,
        meta: {
            name: '广告赞助',
            description: '趣宠会（天津国际AI+宠物产业博览会）广告赞助栏目，介绍展会广告位与赞助合作方案。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/SellerRegister',
        name: 'SellerRegister',
        component: SellerRegister,
        meta: {
            name: '参展报名',
            description: '趣宠会（天津国际AI+宠物产业博览会）参展报名栏目，为宠物行业企业提供参展申请入口。',
            keywords: siteKeywords,
        },
    },
    {
        path: '/GoWechat',
        name: 'GoWechat',
        component: GoWechat,
        meta: {
            name: '购票',
            keywords: siteKeywords,
        },
    },
    {
        path: '/SpecialHome',
        name: 'SpecialHome',
        component: SpecialHome,
        meta: {
            name: '专业观众',
            keywords: siteKeywords,
        },
    },
    {
        path: '/SpecialAudit',
        name: 'SpecialAudit',
        component: SpecialAudit,
        meta: {
            name: '专业观众',
            keywords: siteKeywords,
        },
    },
    {
        path: '/SpecialCode',
        name: 'SpecialCode',
        component: SpecialCode,
        meta: {
            name: '专业观众',
            keywords: siteKeywords,
        },
    },
    {
        path: '/AuditSuccess',
        name: 'AuditSuccess',
        component: AuditSuccess,
        meta: {
            name: '审核完成',
            keywords: siteKeywords,
        },
    },
    {
        path: '/SpecialPolicy',
        name: 'SpecialPolicy',
        component: SpecialPolicy,
        meta: {
            name: '活动规则说明',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ticketing/:id',
        name: 'ticketing',
        component: GoWechat,
        meta: {
            name: '购票',
            keywords: siteKeywords,
        },
    },
    {
        path: '/buy',
        name: 'buy',
        component: GoWechat,
        meta: {
            name: '购票',
            keywords: siteKeywords,
        },
    },
    {
        path: '/ticketing',
        name: 'ticketing',
        component: GoWechat,
        meta: {
            name: '购票',
            keywords: siteKeywords,
        },
    },
    {
        path: '/signMap',
        name: 'signMap',
        component: SignMap,
        meta: {
            title: '趣宠会——小游戏',
        },
    },
    {
        path: '/exhibitor',
        name: 'exhibitor',
        component: Exhibitor,
        meta: {
            name: '展商专区',
            keywords: siteKeywords,
        },
    },
    {
        path: '/receive',
        name: 'receive',
        component: ActivityReceive,
        meta: {
            title: '趣宠会——小游戏',
        },
    },
    {
        path: '/exScan',
        name: 'exScan',
        component: ExhibitorScan,
        meta: {
            name: '现场核销',
            keywords: siteKeywords,
        },
    },
    {
        path: '/serviceScan',
        name: 'serviceScan',
        component: ServiceScan,
        meta: {
            name: '现场服务',
            keywords: siteKeywords,
        },
    },
    {
        path: '/gift',
        name: 'gift',
        component: GiftList,
        meta: {
            name: '礼品兑换',
            keywords: siteKeywords,
        },
    },{
        path: '/petFriendly',
        name: 'petFriendly',
        component: PetFriendly,
        meta: {
            name: '宠物友好',
            keywords: siteKeywords,
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    //mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

/* ========== SEO 动态更新（title / description / keywords / canonical） ========== */
function setHeadMeta(name, content) {
    if (!content) return;
    let el = document.querySelector('meta[name="' + name + '"]');
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

function resolvePageTitle(meta) {
    if (meta.title) return meta.title;                       // 显式标题优先（首页、小游戏页）
    if (meta.name) return meta.name + ' | ' + siteTitle;     // 「页面名 | 品牌词」
    return siteTitle;
}

function resolveDescription(meta) {
    if (meta.description) return meta.description;
    if (meta.name) return defaultDesc;
    return defaultDesc;
}

router.beforeEach((to, from, next) => {
    const meta = to.meta || {};
    document.title = resolvePageTitle(meta);
    setHeadMeta('description', resolveDescription(meta));
    setHeadMeta('keywords', meta.keywords || siteKeywords);

    // canonical 指向当前完整 URL，帮助搜索引擎识别页面规范地址（含查询参数的详情页保留参数）
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + to.fullPath);

    next();
    window.scrollTo(0, 0)
});

export default router
